export default __webpack_public_path__ + "static/16-0276e23c8fd5ca4ea1fd6677e89819bd.jpg";